/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import { devices } from "components/shared/Styles";
import { AppHeaderHeight } from "components/shared/AppHeader/AppHeaderHeight";

const BannerHeight = "48px";

export const FixedBanner = styled.header<{ color?: string }>`
  position: relative;
  top: ${AppHeaderHeight};
  box-sizing: border-box;
  height: ${BannerHeight};
  display: flex;
  flex-direction: row;
  flex: 1 1 0;
  width: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 14px 0px 16px 8px;
  background: ${({ color }): string => color ?? "#edeeff"};

  ${devices.small} {
    align-items: start;
    flex-direction: column;
    height: auto;
    padding: 18px;
  }
`;
